import { createFileRoute } from "@tanstack/react-router";
import AdminPushDetailPage from "@/admin/pages/push-detail";

export const Route = createFileRoute("/admin/push/$id")({
  component: AdminPushDetailPage,
});
